import React from "react";
import { Folder, ChevronRight } from "lucide-react";

export const RepoBreadcrumbs = ({ breadcrumbs, onNavigate }) => (
  <div className="repo-breadcrumbs">
    {breadcrumbs.length <= 4 ? (
      breadcrumbs.map((b, i) => (
        // Mark the last crumb as the current directory.
        <React.Fragment key={b.id || "root"}>
          <span
            className={`repo-breadcrumb-item ${
              i === breadcrumbs.length - 1 ? "current" : ""
            }`}
            onClick={
              i === breadcrumbs.length - 1 ? undefined : () => onNavigate(b.id, b.name)
            }
            aria-current={i === breadcrumbs.length - 1 ? "page" : undefined}
            title={b.name}
          >
            {i === 0 ? <Folder size={18} /> : null}
            <span className="repo-breadcrumb-text">{b.name}</span>
          </span>
          {i < breadcrumbs.length - 1 && (
            <ChevronRight size={14} className="repo-breadcrumb-separator" />
          )}
        </React.Fragment>
      ))
    ) : (
      <>
        <React.Fragment key={breadcrumbs[0].id || "root"}>
          <span
            className="repo-breadcrumb-item"
            onClick={() => onNavigate(breadcrumbs[0].id, breadcrumbs[0].name)}
            title={breadcrumbs[0].name}
          >
            <Folder size={18} />
            <span className="repo-breadcrumb-text">{breadcrumbs[0].name}</span>
          </span>
          <ChevronRight size={14} className="repo-breadcrumb-separator" />
        </React.Fragment>

        <div className="dropdown border-0 d-flex align-items-center">
          <span
            className="repo-breadcrumb-item repo-breadcrumb-ellipsis"
            data-bs-toggle="dropdown"
            title="Hidden folders"
          >
            ...
          </span>
          <ul className="dropdown-menu">
            {breadcrumbs.slice(1, -2).map((b) => (
              <li key={b.id}>
                <button
                  className="dropdown-item"
                  onClick={() => onNavigate(b.id, b.name)}
                >
                  <Folder size={14} style={{ marginRight: "8px" }} />
                  {b.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <ChevronRight size={14} className="repo-breadcrumb-separator" />

        {breadcrumbs.slice(-2).map((b, i) => (
          <React.Fragment key={b.id}>
            <span
              className={`repo-breadcrumb-item ${
                i === 1 ? "current" : ""
              }`}
              onClick={i === 1 ? undefined : () => onNavigate(b.id, b.name)}
              aria-current={i === 1 ? "page" : undefined}
              title={b.name}
            >
              <span className="repo-breadcrumb-text">{b.name}</span>
            </span>
            {i < 1 && (
              <ChevronRight size={14} className="repo-breadcrumb-separator" />
            )}
          </React.Fragment>
        ))}
      </>
    )}
  </div>
);
